import gql from 'graphql-tag';
import User from '../../entity/User';
import { UserStub } from '@kaizenplatform/kaizen-offer-entity';
import { UserId } from '@kaizenplatform/kaizen-id-entity';
import GraphQLClient from '../../adapter/GraphQLClient';

class UserWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ idGraphqlClient }: { idGraphqlClient: GraphQLClient }) {
    this.graphqlClient = idGraphqlClient;
  }

  public getStubUserById = async (): Promise<User> => {
    const result = {
      User: new UserStub(),
    };
    return User.fromJSON(result.User);
  };

  public getUserById = async (userId: UserId): Promise<User> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query user($id: ID!) {
            user(id: $id) {
              id
              name
              profileImageUrl
              comment
              createdAt
            }
          }
        `,
        {
          id: userId,
        },
      );

      if (result.user === null) {
        throw new UserNotFound({
          userId,
        });
      }

      return User.fromJSON(result.user) as User;
    } catch {
      throw new RequestFailed({ userId });
    }
  };
}

export class UserNotFound extends Error {
  public readonly name = 'UserNotFound';
  public readonly message: string;
  public readonly userId: UserId;

  constructor({ userId }: { userId: UserId }) {
    super();

    this.userId = userId;
    this.message = `User (id = ${userId}) is not found.`;
  }
}

export class RequestFailed extends Error {
  public readonly name = 'PageNotFound';
  public readonly userId: UserId;

  constructor({ userId }: { userId: UserId }) {
    super();
    this.userId = userId;
    this.message = `Request error (UserId = ${userId}). `;
  }
}

export default UserWebApi;
